import { ModelSagres } from "@/types/model-sagres";

export class RespostasOutrasAvaliacoes extends ModelSagres {
    criterioId: number
    dhAvaliacao: string
    dhResposta: string
    cpfAuditor: string

    nomeAuditor: string

    constructor(obj?: any) {
        super()
        if (obj) {
            if (obj.criterioId) this.criterioId = obj.criterioId
            if (obj.dhAvaliacao) this.dhAvaliacao = obj.dhAvaliacao
            if (obj.dhResposta) this.dhResposta = obj.dhResposta
            if (obj.cpfAuditor) this.cpfAuditor = obj.cpfAuditor

            if (obj.nomeAuditor) this.nomeAuditor = obj.nomeAuditor
        }
    }
}